import React, { useEffect, useState } from 'react';
import { Loader2, Plus, Trash2, Save } from 'lucide-react';
import { AdminGate, adminFetch } from '../components/admin/AdminGate';

const EMPTY = { title: '', date: '', time: '', location: '', description: '', link: '' };

function ImpactEditor() {
  const [v, setV] = useState({ raised: '', kids: '' });
  const [msg, setMsg] = useState('');
  useEffect(() => { adminFetch('/sponsor/impact').then((r) => r.json()).then((d) => setV({ raised: String(d.raised), kids: String(d.kids) })); }, []);
  const save = async (e) => {
    e.preventDefault();
    const r = await adminFetch('/admin/sponsor/impact', { method: 'PUT', body: JSON.stringify({ raised: Number(v.raised), kids: Number(v.kids) }) });
    setMsg(r.ok ? 'Saved — live on the Sponsor page.' : 'Save failed.');
  };
  return (
    <form onSubmit={save} className="rounded-3xl bg-white border border-splash-sand p-5 mb-6" data-testid="admin-impact-form">
      <h2 className="font-display font-bold text-xl text-splash-green">Impact counter</h2>
      <p className="text-xs text-splash-green/60 mb-3">Copy the latest totals from Givebutter.</p>
      <div className="flex flex-col sm:flex-row gap-3 sm:items-end">
        <label className="text-xs font-semibold text-splash-green/70">$ raised<input type="number" min="0" step="1" required value={v.raised} onChange={(e) => setV({ ...v, raised: e.target.value })} className="input mt-1 sm:w-40" data-testid="impact-raised-input" /></label>
        <label className="text-xs font-semibold text-splash-green/70">Kids sponsored<input type="number" min="0" step="1" required value={v.kids} onChange={(e) => setV({ ...v, kids: e.target.value })} className="input mt-1 sm:w-40" data-testid="impact-kids-input" /></label>
        <button type="submit" className="inline-flex items-center gap-1 rounded-full bg-splash-teal text-white px-5 py-2.5 text-sm font-semibold" data-testid="impact-save-btn"><Save className="w-4 h-4" /> Save</button>
      </div>
      {msg && <div className="text-xs text-splash-green/70 mt-2" data-testid="impact-save-status">{msg}</div>}
    </form>
  );
}

function EventsEditor() {
  const [events, setEvents] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [err, setErr] = useState('');
  const load = () => adminFetch('/admin/sponsor/events').then((r) => r.json()).then((d) => setEvents(d.events || []));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault(); setErr('');
    const r = await adminFetch('/admin/sponsor/events', { method: 'POST', body: JSON.stringify(form) });
    if (!r.ok) { setErr('Please add a title and date.'); return; }
    setForm(EMPTY); load();
  };
  const del = async (id) => { await adminFetch(`/admin/sponsor/events/${id}`, { method: 'DELETE' }); load(); };
  const f = (k, ph, type = 'text', req = false) => (
    <input type={type} required={req} placeholder={ph} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="input" data-testid={`event-${k}-input`} />
  );
  return (
    <section className="rounded-3xl bg-white border border-splash-sand p-5" data-testid="admin-events">
      <h2 className="font-display font-bold text-xl text-splash-green">Hope Floats event calendar</h2>
      <p className="text-xs text-splash-green/60 mb-3">Past events hide automatically. You&rsquo;ll get a reminder email a week before each month starts.</p>
      <form onSubmit={add} className="grid sm:grid-cols-2 gap-3 mb-5">
        {f('title', 'Event title *', 'text', true)}
        {f('date', 'Date', 'date', true)}
        {f('time', 'Time (e.g. 10:00 AM – 12:00 PM)')}
        {f('location', 'Location')}
        {f('link', 'Link (optional)', 'url')}
        {f('description', 'Short description')}
        <button type="submit" className="sm:col-span-2 inline-flex items-center justify-center gap-1 rounded-full bg-splash-coral text-white py-2.5 font-semibold" data-testid="event-add-btn"><Plus className="w-4 h-4" /> Add event</button>
        {err && <div className="sm:col-span-2 text-sm text-red-600">{err}</div>}
      </form>
      {events === null ? <Loader2 className="w-5 h-5 animate-spin text-splash-teal" /> : events.length === 0 ? <div className="text-sm text-splash-green/60">No events yet.</div> : (
        <ul className="divide-y divide-splash-sand/60">
          {events.map((ev) => (
            <li key={ev.id} className="py-3 flex items-start gap-3 text-sm" data-testid={`admin-event-${ev.id}`}>
              <div className="w-24 shrink-0 font-semibold text-splash-coralDark">{ev.date}</div>
              <div className="flex-1"><div className="font-semibold text-splash-green">{ev.title}</div><div className="text-splash-green/70">{[ev.time, ev.location].filter(Boolean).join(' · ')}</div></div>
              <button type="button" onClick={() => del(ev.id)} aria-label="Delete event" data-testid={`admin-event-delete-${ev.id}`} className="p-1.5 text-splash-green/50 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default function AdminSponsor() {
  return <AdminGate title="Sponsor Page Admin"><ImpactEditor /><EventsEditor /></AdminGate>;
}
